module.exports = __webpack_public_path__ + "img/top.4a832d41.jpg";